<template>
  <section class="top">
    <AppNavigation />

    <section class="sort">
      <section class="relative sort__row">
        <div class="sort__item align-center" data-elem="period">
          <p class="sort__label">Период</p>
          <div class="align-center" @click="openList">
            <div class="sort__selected">{{ selected.period.value }}</div>
            <div class="sort__arrow"><img src="@/assets/img/svg/down.svg" alt=""></div>
          </div>
        </div>

        <ul class="list list__selects" v-if="openedList === 'period'">
          <li v-for="period in periods"
              class="list__select"
              :key="period.weeksCount"
              :data-selected="period.weeksCount"
              :data-value="period.value"
              @click="changeSelected">
                {{ period.weeksCount }}
          </li>
        </ul>
      </section>

      <section class="relative">
        <div class="sort__item align-center" data-elem="tag">
          <p class="sort__label">Тег</p>
          <div class="align-center" @click="openList">
            <div class="sort__selected">#{{ selected.tag.value }}</div>
            <div class="sort__arrow"><img src="@/assets/img/svg/down.svg" alt=""></div>
          </div>
        </div>

        <ul class="list list__selects" v-if="openedList === 'tag'">
          <li v-for="tag in getTags"
              class="list__select"
              :key="tag.tagName"
              :data-selected="tag.tagName"
              :data-selectedId="tag.id"
              @click="changeSelected">
                {{ tag.tagName }}
          </li>
        </ul>
      </section>

      <section class="relative">
        <div class="sort__item align-center" data-elem="userGroup">
          <p class="sort__label">Категория посетителей</p>
          <div class="align-center" @click="openList">
            <div class="sort__selected">{{ selected.userGroup.value }}</div>
            <div class="sort__arrow"><img src="@/assets/img/svg/down.svg" alt=""></div>
          </div>
        </div>

        <ul class="list list__selects" v-if="openedList === 'userGroup'">
          <template v-for="group in userTypes">
            <li
              v-if="Object.keys(excludes).length === 0 || excludes.userTypes && !excludes.userTypes.includes(parseInt(group.id))"
              class="list__select"
              :key="group.groupName"
              :data-selected="group.groupName"
              :data-selectedId="group.id"
              @click="changeSelected">
                {{ group.groupName }}
          </li>
          </template>

        </ul>
      </section>

      <section class="relative">
        <div class="sort__item align-center" data-elem="vendor">
          <p class="sort__label">Вендор</p>
          <div class="align-center" @click="openList">
            <div class="sort__selected">{{ selected.vendor.value }}</div>
            <div class="sort__arrow"><img src="@/assets/img/svg/down.svg" alt=""></div>
          </div>
        </div>

        <ul class="list list__selects" v-if="openedList === 'vendor'">
          <li v-for="vendor in getVendors"
              class="list__select"
              :key="vendor.vendorName"
              :data-selected="vendor.vendorName"
              :data-selectedId="vendor.id"
              @click="changeSelected">
                {{ vendor.vendorName }}
          </li>
        </ul>
      </section>
    </section>
  </section>
</template>

<script>
import AppNavigation from '@/components/PageNavigation.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'AppTop',
  props: ['exclude'],
  components: {
    AppNavigation,
  },
  data() {
    return {
      periods: [
        { weeksCount: '4 недели', value: 4 },
        { weeksCount: '12 недель', value: 12 }
      ],
      periodSelected: '4 недели',
      openedList: '',
      excludes: {}
    }
  },
  computed: {
    ...mapGetters(['getUserTypes', 'getTags', 'getVendors']),
    selected: function() {
      return this.$store.state.filters.filter;
    },
    userTypes: function() {
      let filter = [],
          filteredArr = [];
      if ( this.$route.name === 'AmwayUA' ) {
        filter = ['Public', 'RC', 'PA', 'ABO'];
        this.updateFiltredArr(filter, filteredArr);
      } else {
        filter = ['Public', 'RC', 'SE', 'VIP', 'VIP+', 'ABO'];
        this.updateFiltredArr(filter, filteredArr);
      }

      return filteredArr;
    },
  },
  methods: {
    openList() {
      if (event) {
        const wrapper = event.target.closest('.sort__item');
        const arrow = wrapper.querySelector('.sort__arrow');
        if ( this.openedList === wrapper.dataset.elem ) {
          this.openedList = '';
          arrow.classList.remove('sort__arrow_active');
        } else {
          this.openedList = wrapper.dataset.elem;
          arrow.classList.add('sort__arrow_active');
        } 
      }
    },

    changeSelected() {
      const arrow = document.querySelector('.sort__arrow_active');
      this.$store.commit('setFilter', {
        name: this.openedList,
        value: event.target.dataset.selected,
        id: event.target.dataset.selectedid || event.target.dataset.value,
      });

      this.openedList = '';
      arrow.classList.remove('sort__arrow_active');
    },

    updateFiltredArr(filter, arr) {
      filter.forEach(el => {
        arr.push(
          this.getUserTypes.find(obj => obj.groupName === el)
        )
      })
    },
  },
  created() {
    const self = this;
    Object.assign(this.excludes, this.exclude);
    document.addEventListener('click', function(e) {
       if (self.openedList && e.target.className !== "sort__selected") {
         const arrow = document.querySelector('.sort__arrow_active');
         arrow.classList.remove('sort__arrow_active');
         self.openedList = '';

       }
    });
  }
}
</script>

<style lang="scss" scoped>
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 19px;
  }

  .navigation {
    display: flex;
    background: #FFFFFF;

    &__item {
      padding: 15px 19px;
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
      box-sizing: border-box;

      color: #56565A;
      transition: all .3s ease;

      &:hover {
        color: #034580;
        background: #F2F9FC;
      }

      &_active {
        font-weight: 700;
        background: #F2F9FC;
        color: #034580;
        border-bottom: 2px solid #034580; 
      }
    }
  }

  .sort {
    display: flex;

    &__item {
      margin-left: 30px;
    }

    &__selected {
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      margin-left: 10px;
      margin-right: 2px;

      color: #034580;
      cursor: pointer;
    }

    &__arrow {
      cursor: pointer;
      transition: all .3s ease;

      &_active {
        transform: rotate(180deg);
      }
    }

    &__label {
      font-size: 14px;
      line-height: 16px;
      color: #000000;
    }
  }

  .list__selects {
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    position: absolute;
    z-index: 3;
    right: -10px;
    top: 25px;
    background: #FFFFFF;
    border-radius: 3px;
  }
  .list__select {
    padding: 10px 20px;
    transition: all .3s ease;
    border-radius: 3px;
    cursor: pointer;

    &:hover {
      background-color: #B8EAFF;
    }
  }
</style>
